import React from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { useNavigate, Navigate, Link } from "react-router-dom";
export default function FollowUpForm() {
  const navigate = useNavigate();

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-4">
                <div className="container-fluid  py-4 md-4 my-4">
                  <form className="card g-3 p-4 py-4">
                    <div className="row">
                      <div className="col-6">
                        <label className="form-label fw-bold">Follow Up</label>
                        <select className="form-select">
                          <option>Enquiry</option>
                          <option>Call Back</option>
                          <option>Admission</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold">Student Name</label>
                        <input
                          type="text"
                          className="form-control"
                          defaultValue="abhijeet saini"
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Father's Name</label>
                        <input type="text" className="form-control" />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold">Mobile</label>
                        <input
                          type="text"
                          className="form-control"
                          defaultValue="09785493798"
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Education</label>
                        <select className="form-select">
                          <option>12th Pass</option>
                          <option>10th Pass</option>
                          <option>Graduate</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold">State</label>
                        <input
                          type="text"
                          className="form-control"
                          defaultValue="Rajasthan"
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">District</label>
                        <select className="form-select">
                          <option>Select District</option>
                          <option>Jaipur</option>
                          <option>Ajmer</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold">Village</label>
                        <input type="text" className="form-control" defaultValue="Chomu" />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Tehsil</label>
                        <input type="text" className="form-control" defaultValue="chomu" />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold">Reference Detail</label>
                        <textarea className="form-control" rows="2"></textarea>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Course</label>
                        <select className="form-select">
                          <option>Select Course</option>
                          <option>Biology</option>
                          <option>Maths</option>
                        </select>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold">Assign to</label>
                        <select className="form-select">
                          <option>Select Counselor</option>
                          <option>Abhijeet</option>
                          <option>Sonia</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Next FollowUp Date</label>
                        <input type="date" className="form-control" />
                      </div>

                      <div className="col-12 text-end mt-5">
                        <button type="submit" className="btn btn-primary mx-2">
                          Save
                        </button>
                        <Link to={"/marketing/all-students"}>
                          <button className="btn btn-danger">
                            Back
                          </button></Link>
                      </div>
                    </div>
                  </form>
                </div></div>
            </div></div>
        </div></div>
    </>
  );
}
